<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 36 12"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_224" data-name="Rectangle 224" width="36" height="12" fill="#1b16e6" />
            </clipPath>
        </defs>
        <g id="Group_1033" data-name="Group 1033" :clip-path="`url(#clip-path-${uniqueId})`">
            <path
                id="Path_244"
                data-name="Path 244"
                d="M21.618,12.683c-.021,1.6,1.443,2.5,2.546,3.033,1.133.546,1.514.9,1.509,1.385-.009.748-.9,1.078-1.742,1.091a6.122,6.122,0,0,1-2.987-.7l-.527,2.441a8.829,8.829,0,0,0,3.235.591c3.055,0,5.054-1.494,5.065-3.811.012-2.941-4.1-3.1-4.077-4.418.01-.4.393-.824,1.235-.932a5.521,5.521,0,0,1,2.868.5l.511-2.362A7.858,7.858,0,0,0,26.533,9C23.657,9,21.635,10.515,21.618,12.683ZM34.168,9.2a1.326,1.326,0,0,0-1.238.817L28.566,20.346h3.053l.608-1.664h3.731l.352,1.664H39L36.652,9.2Zm.428,3.01.881,4.184H33.064ZM17.917,9.2,15.51,20.346H18.42L20.825,9.2Zm-4.3,0-3.028,7.584L9.361,10.339A1.353,1.353,0,0,0,8.019,9.2H3.069L3,9.527a12.189,12.189,0,0,1,2.87.948,1.221,1.221,0,0,1,.691.979l2.32,8.892h3.074L16.669,9.2Z"
                transform="translate(-4.25 -9)"
                fill="#1b16e6"
                fill-rule="evenodd" />
            <path
                id="Path_332"
                data-name="Path 332"
                d="M21.618,12.683c-.021,1.6,1.443,2.5,2.546,3.033,1.133.546,1.514.9,1.509,1.385-.009.748-.9,1.078-1.742,1.091a6.122,6.122,0,0,1-2.987-.7l-.527,2.441a8.829,8.829,0,0,0,3.235.591c3.055,0,5.054-1.494,5.065-3.811.012-2.941-4.1-3.1-4.077-4.418.01-.4.393-.824,1.235-.932a5.521,5.521,0,0,1,2.868.5l.511-2.362A7.858,7.858,0,0,0,26.533,9C23.657,9,21.635,10.515,21.618,12.683ZM34.168,9.2a1.326,1.326,0,0,0-1.238.817L28.566,20.346h3.053l.608-1.664h3.731l.352,1.664H39L36.652,9.2Zm.428,3.01.881,4.184H33.064ZM17.917,9.2,15.51,20.346H18.42L20.825,9.2Zm-4.3,0-3.028,7.584L9.361,10.339A1.353,1.353,0,0,0,8.019,9.2H3.069L3,9.527a12.189,12.189,0,0,1,2.87.948,1.221,1.221,0,0,1,.691.979l2.32,8.892h3.074L16.669,9.2Z"
                transform="translate(-4.25 -9)"
                fill="#bfbca5"
                fill-rule="evenodd"
                style="mix-blend-mode: color; isolation: isolate" />
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
